import io from 'socket.io-client'
import axios from 'axios';


class ChatService {

    constructor(props) {
        this.connected = false;
        this.chatUrl = "";
    }

    connect = async (url, id) => {

        if (!this.connected) {
            this.connected = true;
            let hostName = window.location.hostname,
                chatUrl = `https://${url}`;

            //! TODO: Trampa
            if (hostName === 'localhost' || hostName === '127.0.0.1' || hostName === "dev.andrei.io")
                chatUrl = "https://devomni.fidelitycloud.es:3000";

            this.chatUrl = chatUrl;
            this.isConnected = this.isConnected.bind(this);
            this.socket = await io.connect(this.chatUrl, { query: `agt=${id}M` });
            this.socket.on('connection-test', this.isConnected);
        }
    }

    isConnected(data) {
        console.log("*******************\n* SOCKET CONNECTED.\n*******************");
        this.connected = true;
    }

    registerInitChat = (callback) => {
        this.socket.on('initConversation', function (chat) {
            callback(chat);
        });
    }

    registerAddMessage = (callback) => {
        this.socket.on('updateUpdateConversation', function (message) {
            callback(message);
        });
    }

    registerChatClosed = (callback) => {
        this.socket.on('conversationClosed', function (id) {
            callback(id);
        });
    }

    registerTransferError = (callback) => {
        this.socket.on('transferError', function (message) {
            callback(message);
        });
    }
    
    closeChat = (id) => {
        this.socket.emit('closeConversation', id);
    }

    getChat(guid, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/conversations/getchat",
            data: {
                "guid": guid
            },
        }).then(res => {
            callBack(res);
        });
    }
    getChatById(id, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/conversations/getchat",
            data: {
                "id": id
            },
        }).then(res => {
            callBack(res);
        });
    }
    initChat(userId, name, supervisorId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/initInternalChat",
            data: {
                pin: userId,
                name: name,
                from: supervisorId + "M"
            }
        }).then(res => {
            callBack(res);
        });
    }

    sendMessage(message, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/conversations/addagentmessage",
            data: message,
        }).then(res => {
            callBack(res);
        });
    }

    transferChat(userId, groupId, conversationId, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/transferChat",
            data: { conversationId: conversationId, agentId: userId, groupId: groupId },
        }).then(res => {
            callBack(res);
        });
    }

    transferChatSupervisor(userId, groupId, conversationId, pin, callBack) {
        axios({
            method: "post",
            url: this.chatUrl + "/transferChatSupervisor",
            data: { conversationId: conversationId, agentId: userId, groupId: groupId, pin: pin },
        }).then(res => {
            callBack(res);
        });
    }

}

const chatService = new ChatService();
export default chatService;